import { BaseContainerModel } from "../../base-container.model";
import { bl_cms_website_entity_link_RowClass } from "../../../dbschema";
import { bl_cms_website_fi_label_list_link_RowClass } from "../../../dbschema/bl_cms_website_fi_label_list_link.model";

export class WebsiteFiLableListLinkContainerModel extends BaseContainerModel {
  bl_cms_website_fi_label_list_link: bl_cms_website_fi_label_list_link_RowClass =
    new bl_cms_website_fi_label_list_link_RowClass();
}
